import { LANG_V2, REP_V2 } from "../../../shared/Data/typeDirs";
import { ModalContainer } from "./containers/modal";
import { LanguageHeader } from "./language_v2/header";
import { ReportBodyWrapper } from "./reports_v2/body";
import { ReportHeaderWrapper } from "./reports_v2/header";
import { UserHeaderWrapper } from "./user/header";

const wrapperMap = {
  [REP_V2]:{ header: ReportHeaderWrapper, body:ReportBodyWrapper},
  [LANG_V2]:{ header: LanguageHeader },
  user: {header: UserHeaderWrapper},
  containers: { modal: ModalContainer }
}
export {wrapperMap}